import React from "react";
import HeaderNormal from "../header/HeaderNormal";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TitleSection from "../heading/TitleSection";
import Footer from "../footer/Footer";
import ProductionVideoList from "./ProductionVideoList";
import PageSeo from "../seo/PageSeo";
import { getPageSeo } from "../../seo/siteSeo";

export const ProductionVideo = () => {
  const { t, i18n } = useTranslation("common");
  const seo = getPageSeo(i18n.resolvedLanguage || i18n.language, "videoProduction");

  return (
    <React.Fragment>
      <PageSeo
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/video-production"
      />

      <HeaderNormal className="background-section text-uppercase" description={t("Mes dernières réalisations")}>
        {t("Notre Production Vidéo")}
      </HeaderNormal>

      <Container className="mt-section">
        <TitleSection description={t("Projets vidéo réalisés")} />
        <ProductionVideoList />
      </Container>

      <br /><br />
      <Footer />
    </React.Fragment>
  );
};
